import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "payment-condition__icon__title__ref d-flex caption-strong align-items-center gap-1" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "payment-condition__title__ref m-0" }
const _hoisted_5 = { class: "payment-condition-description m-0 mt-1 caption" }
const _hoisted_6 = {
  key: 0,
  class: "mt-1"
}



  interface Props {
    borderClass: string
    textClass: string
    backgroundClass?: string
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BasePaymentCondition',
  props: {
    borderClass: {},
    textClass: {},
    backgroundClass: {}
  },
  setup(__props: any) {

  const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", {
        class: _normalizeClass(["payment-condition-icon d-flex align-items-center gap-1 m-0", [props.borderClass, props.textClass, props.backgroundClass]])
      }, [
        _createElementVNode("span", _hoisted_3, [
          _renderSlot(_ctx.$slots, "payment-condition-icon")
        ]),
        _createElementVNode("span", null, [
          _renderSlot(_ctx.$slots, "payment-condition-type")
        ])
      ], 2),
      _createElementVNode("p", _hoisted_4, [
        _renderSlot(_ctx.$slots, "payment-condition__title__ref")
      ])
    ]),
    _createElementVNode("p", _hoisted_5, [
      _renderSlot(_ctx.$slots, "payment-condition-description")
    ]),
    (_ctx.$slots['terms-and-conditions'])
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "terms-and-conditions")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})